module.exports = __webpack_public_path__ + "img/jg.ffcf1cbb.png";